<template>
  <div class="main-header" :class="isScroll ? 'fixed' : ''">
    <div class="header">
      <div class="header-logo">
        <div class="header-img">
          <a href=""><img src="../assets/images/logo_ico.png" /></a>
        </div>
        <div class="header-text" :style="{ color: tabIndex == 0 ? '#FFF' : '#333333' }">
          <div class="header-tleft">
            <a href="" :style="{ color: tabIndex == 0 ? '#FFF' : '#333333' }">
              <div class="header-title-top">全国蔬菜质量标准中心</div>
              <div class="header-title-down status">标准化园区产销对接平台</div>
            </a>
          </div>
          <div class="header-tmid"></div>
          <div class="header-tright">
            <div class="header-title-top">甄选蔬菜&nbsp;&nbsp;标准化好产品</div>
            <div class="header-title-down">
              Select Standard Good Vegetable Products
            </div>
          </div>
        </div>
        <!-- <a href=""><img :src="titleUrl" /></a> -->
      </div>
      <div class="header-nav">
        <ul class="nav">
          <li :class="item.selected ? 'active' : ''" v-for="(item, index) in tabList" :key="index"
            @click="clickTab(item, index)">
            <a href="javascript:;">{{ item.name }}</a>
          </li>
        </ul>
        <div class="name" v-if="userName">
          <el-dropdown size="large">
            <span @click="showExit = !showExit" class="name_text" style="font-size: 12px">{{ userName }}</span>
            <!-- <div v-if="showExit" class="name-exit" @click="exitLogin">
                      退出登录
                    </div> -->
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="toPC">进入后台</el-dropdown-item>
                <el-dropdown-item @click="exitLogin">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <!-- <span class="login_text">已登录</span> -->
        </div>
        <div class="header-log" @click="clickLogin" v-else>
          <img class="log-icon" src="../assets/images/icon1.png" />
          <span>登录</span>
        </div>
      </div>
    </div>
</div>
</template>
<script setup>
import { getZZJHParams } from "@/api/base";
import { date2str, encryptByDES } from "@/utils/login_crypto";
import { pcRoot } from "@/utils/pc_root";
import { ElMessage } from "element-plus";
import { onMounted, reactive, toRefs } from "vue";
const state = reactive({
  tabList: [
    { name: "网站首页", selected: true, url: "home" },
    { name: "园区名录", selected: false, url: "base" },
    { name: "产品目录", selected: false, url: "production" },
    { name: "供需信息", selected: false, url: "purchase" },
    { name: "关于我们", selected: false, url: "aboutUs" },
  ],
  // imgUrl: "",
  showExit: false,
});
const { tabList, showExit } = toRefs(state);

const props = defineProps({
  isScroll: {
    type: Boolean,
    default: false,
  },
  titleUrl: {
    type: String,
    default: require("../assets/images/logo4.png"),
  },
  tabColor: {
    type: String,
    default: "#333",
  },
  tabIndex: {
    type: [String, Number],
    default: 0,
  },
  userName: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["clickItem", "clickLogin", "acceptUserName"]);
const clickTab = (item) => {
  emits("clickItem", item);
};
const clickLogin = () => {
  emits("clickLogin", true);
};
const exitLogin = () => {
  showExit.value = false;
  localStorage.removeItem("token");
  localStorage.removeItem("roleInfo");
  localStorage.removeItem("userName");
  window.location.reload();
};
// 跳转pc
const toPC = () => {
  let account = localStorage.getItem("phone");
  let params = { userName: account };

  getZZJHParams(params)
    .then((res) => {
      if (res.code == 0) {
        let uuid = res.datas;
        let nowtime = date2str(new Date(), "yyyyMMdd");
        let txt1 = encodeURIComponent(
          encryptByDES(account, nowtime + "microcloud")
        );

        let txt2 = encodeURIComponent(
          encryptByDES(uuid, nowtime + "microcloud")
        );

        let url = pcRoot() + "login.html?txt1=" + txt1 + "&txt2=" + txt2;
        window.open(url);
      } else {
        ElMessage.error(res.msg);
      }
    })
    .catch((err) => {
      ElMessage.error(err.response.data.msg);
    });

  // window.location.href = 'http://172.10.0.39:8068/zxsc/pages/plantPlan/plantPlan_list.html';
  // window.open('http://172.10.0.39:8068/zxsc/pages/plantPlan/plantPlan_list.html');
};
// 处理tab的下边 对应展示
onMounted(() => {
  tabList.value.map((item, index) => {
    if (index == props.tabIndex) item.selected = true;
    else item.selected = false;
  });
});
</script>
<style lang="scss" scoped>
.main-header {
  // position: absolute;
  // z-index: 99;
  // top: 0;
  // left: 0;
  width: 100%;

  // margin: auto;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 184px;
    padding: 0 100px 0 220px;

    transition: all 300ms;

    .header-logo {
      display: flex;
      align-items: center;

      .header-img {
        img {
          width: 100px;
          height: 100px;
        }
      }

      .header-text {
        display: flex;

        .header-tleft {
          margin-right: 10px;
          margin-left: 10px;

          .header-title-top {
            letter-spacing: 4px;

            font-size: 2.9rem;
            font-weight: bold;
          }

          .header-title-down {
            letter-spacing: 2px;

            font-size: 2.5rem;
            font-weight: bold;
          }

          .status {
            letter-spacing: 5.5px;
          }
        }

        .header-tmid {
          width: 1px;

          background-color: #0ba29a;
          // height: 100%;
        }

        .header-tright {
          margin-top: 10px;
          margin-left: 10px;

          .header-title-top {
            font-size: 2.6rem;
          }

          .header-title-down {
            margin-top: .625rem;

            font-size: 1.25rem;
          }
        }
      }
    }

    .header-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;

      width: 56%;

      .nav {
        display: flex;
        align-items: center;

        width: 80%;

        // margin-right: 100px;

        li {
          // margin: 0 55px;
          width: 20%;

          a {
            position: relative;

            display: block;
            overflow: hidden;

            transition: 300ms;

            color: v-bind(tabColor);

            font-size: 28px;
            line-height: 184px;

            &:before {
              position: absolute;
              top: 0;
              left: -100%;

              display: block;

              width: 100%;
              height: 6px;

              content: '';
              transition: all 300ms;

              background: #0ba29a;
            }
          }

          &:hover {
            a {
              color: #0ba29a;

              &:before {
                left: 0;
              }
            }
          }
        }

        .active {
          a {
            color: #0ba29a;

            font-weight: 600;

            &:before {
              left: 0;
            }
          }
        }
      }

      .name {
        width: 15%;

        color: v-bind(tabColor);

        font-size: 12px;

        .name-exit {
          position: absolute;
          z-index: 9;
          top: 110px;
          right: 230px;

          display: flex;
          align-items: center;
          justify-content: center;

          width: 245px;
          height: 120px;

          color: #666;
          background: url('../assets/images/tuichudenglu.png') no-repeat center;
          background-size: 100% 100%;

          font-size: 26px;
        }

        .login_text {
          padding-left: 20px;

          color: #0ba29a;

          font-size: 26px;
        }
      }
    }

    .header-log {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 80px;
      padding: 0 40px;

      cursor: pointer;
      white-space: nowrap;

      color: #fff;
      border-radius: 8px;
      background: #0ba29a;

      font-size: 28px;

      // width: 6.5%;

      .log-icon {
        display: block;

        margin-right: 8px;
      }
    }
  }
}

.fixed {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;

  width: 100%;

  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);

  .header {
    height: 140px;

    .header-nav {
      li a {
        line-height: 140px;
      }
    }
  }
}
</style>
